import React, { useRef, useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { tg } from '../telegram';

interface CameraCaptureProps {
  isOpen: boolean;
  onCapture: (base64Image: string) => void;
  onClose: () => void;
}

export const CameraCapture: React.FC<CameraCaptureProps> = ({ isOpen, onCapture, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      startCamera();
    } else {
      stopCamera();
    }
    return () => stopCamera();
  }, [isOpen]);

  const startCamera = async () => {
    setError(null);
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
        audio: false,
      });
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
    } catch (err: any) {
      setError(`Không thể mở camera: ${err.message}`);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };

  const takePhoto = () => {
    if (videoRef.current && canvasRef.current) {
      tg.haptic.impact('heavy');
      const video = videoRef.current;
      const canvas = canvasRef.current;

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
        onCapture(dataUrl);
        onClose();
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-sheet" style={{ height: '90vh', padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#000', color: '#fff' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>Chụp Ảnh Hóa Đơn</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff' }}>
            <X size={20} />
          </button>
        </div>

        <div style={{ flex: 1, background: '#000', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {error ? (
            <div style={{ color: '#ff4d4f', padding: 20, textAlign: 'center' }}>
              <p>{error}</p>
              <button onClick={startCamera} className="btn btn-secondary" style={{ marginTop: 10 }}>Thử lại</button>
            </div>
          ) : (
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>

        <div style={{ padding: '20px', background: '#000', display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={takePhoto}
            style={{
              width: 64, height: 64, borderRadius: '50%',
              background: '#fff', border: '4px solid #aaa',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
          >
            <div style={{ width: 48, height: 48, borderRadius: '50%', border: '2px solid #000' }} />
          </button>
        </div>
      </div>
    </div>
  );
};
